var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('a',{staticClass:"anchor",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._t("default")],2):_c('router-link',{staticClass:"anchor",attrs:{"to":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }